/**
 * File types the `issue_evidence` storage bucket accepts, for `<input type="file" accept>`.
 * Keep in step with `storage.buckets.allowed_mime_types` for `issue_evidence` (set by the
 * issue_evidence scope migration). SVG is left out on purpose: it can carry script. The bucket also
 * lists the non-standard `image/jpg`, which browsers never report, so it is not repeated here.
 */
export const ISSUE_EVIDENCE_ACCEPT =
    'image/jpeg,image/png,image/webp,image/gif,image/heic,image/heif,image/avif';
